import { Controller } from "@hotwired/stimulus"

// The one-tap rows on /dev (development only). Fills the block's own hidden
// form and submits it to the real sessions#create. Deliberately FILLS rather
// than forging a session, so the sign-in path being exercised stays the real
// one.
export default class extends Controller {
  static targets = ["form"]

  fill(event) {
    const { email, password } = event.currentTarget.dataset
    const form = this.formTarget

    form.querySelector("input[name='email_address']").value = email
    form.querySelector("input[name='password']").value = password
    form.requestSubmit()
  }

  toggle(event) {
    const collapsed = this.element.classList.toggle("is-collapsed")
    const button = event.currentTarget

    button.setAttribute("aria-expanded", String(!collapsed))
    button.setAttribute(
      "aria-label",
      collapsed ? "Show the dev sign-in list" : "Hide the dev sign-in list"
    )
  }
}
